import { render, staticRenderFns } from "./gallery-submission.vue?vue&type=template&id=38f1153a&scoped=true&"
import script from "./gallery-submission.vue?vue&type=script&lang=js&"
export * from "./gallery-submission.vue?vue&type=script&lang=js&"
import style0 from "./gallery-submission.vue?vue&type=style&index=0&id=38f1153a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f1153a",
  null
  
)

export default component.exports